import { HTMLAttributes, PropsWithChildren } from 'react';

import clsx from 'clsx';

import { AssetClass } from '__generated__/globalTypes';
import { cardsConfig, CardsKey } from '../deals.config';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  disabled?: boolean;
  active?: boolean;
}

export function Card({ disabled, active, className, children, ...rest }: CardProps) {
  return (
    <div
      className={clsx(
        'mb-1 rounded border border-solid border-gray-900 px-4 py-3',
        active
          ? 'bg-background-canvas text-foreground-default'
          : 'bg-background-surface text-foreground-muted',
        disabled ? 'cursor-not-allowed opacity-40' : 'cursor-pointer opacity-100',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export type CardCommonProps = {
  name: CardsKey;
  active?: boolean;
  onClick?: (cardKey: CardsKey) => void;
  dealId?: string;
  assetClass?: AssetClass;
};

export function CardWrapper(props: PropsWithChildren<CardCommonProps>) {
  const config = cardsConfig[props.name];

  return (
    <Card active={props.active}>
      <div
        className="flex cursor-pointer justify-between"
        onClick={() => props.onClick && props.onClick(props.name)}
      >
        <h5 className="mb-2.5">{config.name}</h5>
        <span className={clsx('arrow', props.active && 'rotate-90')}>❯</span>
      </div>
      {props.children}
    </Card>
  );
}
